import React, { useState } from "react";

const UserSettings = () => {
  const [activeTab, setActiveTab] = useState("users");
  const tabs = [
    { key: "users", label: "Users" },
    { key: "roles", label: "Roles" },
    { key: "permissions", label: "Permissions" },
    { key: "assign", label: "Assignments" },
  ];
  return (
    <>
      <div className="section-title_user">
        <div className="sub-toggle">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`pill_user ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button className="add-button_user">Add</button>
      </div>
      {activeTab === "users" && (
        <div id="users" className="sub-panel">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Profile Type</th>
                <th>Status</th>
                <th>Last Login</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      )}
      {activeTab === "roles" && (
        <div id="roles" className="sub-panel">
          <table className="table">
            <thead>
              <tr>
                <th>Role</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      )}
      {activeTab === "permissions" && (
        <div id="permissions" className="sub-panel">
          <table className="table">
            <thead>
              <tr>
                <th>Permission</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      )}
      {/* {activeTab === "assign" && (
        <div id="assign" className="sub-panel">
          <div style={{ display: "flex", gap: 20 }}>
            <div style={{ flex: 1 }}>
              <h4>Select User</h4>
              <ul id="assign-users" />
            </div>
            <div style={{ flex: 1 }}>
              <h4>Assign Roles (multiple allowed)</h4>
              <form id="role-assignment-form" />
              <button className="add-button" id="saveAssignBtn">
                Save
              </button>
            </div>
          </div>
        </div>
      )} */}
      <div id="modalOverlay" className="modal_setting">
        <div
        // className="modal"
        >
          <h3 id="modalTitle" />
          <form id="modalForm" />
          <div style={{ textAlign: "right" }}>
            <button className="add-button" id="saveModalBtn">
              Save
            </button>
            <button className="action-btn" id="cancelModalBtn">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div id="permModalOverlay" className="modal_setting">
        <div className="modal">
          <h3 id="permModalTitle" />
          <div id="permList" />
          <div style={{ textAlign: "right", marginTop: 12 }}>
            <button className="add-button" id="savePermAssignmentsBtn">
              Save
            </button>
            <button className="action-btn" id="cancelPermModalBtn">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSettings;
